export default function Card({children, className, dir, padding, disabled, type}) {
    dir === undefined ? (dir = "") : (dir = dir);
    padding === undefined ? (padding = "int") : (padding = "");
    return (
        <div className={`card ${className} ${dir} ${padding}`} disabled={disabled}>
            {children}
        </div>
    );
}
